import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { RdsTabulationDisplayOptionsComponent } from './tabulation-display-options.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatButtonToggleModule],
  exports: [RdsTabulationDisplayOptionsComponent],
  declarations: [RdsTabulationDisplayOptionsComponent],
})
export class RdsTabulationDisplayOptionsModule {}

export * from './tabulation-display-options.component';
